import api from 'api';
import DesignTemplate from 'records/DesignTemplate';

export const CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_START = 'CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_START';
export const CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS = 'CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS';
export const CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR = 'CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR';
export const CATER_CONCES_DESIGN_TEMPLATES_RESET_STATE = 'CATER_CONCES_DESIGN_TEMPLATES_RESET_STATE';

function caterConcesDesignTemplatesAsyncActionStart() {
  return {
    type: CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_START,
  };
}

function caterConcesDesignTemplatesAsyncActionError(error) {
  return {
    type: CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_ERROR,
    error,
  };
}

function caterConcesDesignTemplatesAsyncActionSuccess(data) {
  return {
    type: CATER_CONCES_DESIGN_TEMPLATES_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetcaterConcesDesignTemplatesState() {
  return {
    type: CATER_CONCES_DESIGN_TEMPLATES_RESET_STATE,
  };
}

export function getcaterConcesDesignTemplates(designTypeId, designSizeId, businessTypeId, layoutId ) {
  return (dispatch, getState) => {
    dispatch(caterConcesDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?designtid=${ designTypeId }&sizeid=${ designSizeId }&typeId=${ businessTypeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(caterConcesDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(caterConcesDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function getcaterConcesThemeDesignTemplates(businessTypeId, layoutId ) {
  return (dispatch, getState) => {
    dispatch(caterConcesDesignTemplatesAsyncActionStart());
    return api.request(
      `design/designtemplates/typeitem?typeId=${ businessTypeId }&layoutId=${layoutId!=undefined?layoutId:-1}`,
      'get',
      null
    )
    .then((data) => {
      dispatch(caterConcesDesignTemplatesAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(caterConcesDesignTemplatesAsyncActionError('Unable to get design templates'));
      throw (err);
    });
  };
}

export function filterCaterConcesDesignTemplates(designTypeId, designSizeId, businessTypeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(caterConcesDesignTemplatesAsyncActionStart());
    let tmpDesignData = getState().caterConcesDesignTemplates.get('data');
    let filterData = DesignTemplate.getDesignTemplatesByTypeAndSizeId(tmpDesignData, designTypeId, designSizeId);

    let filterLayoutData = filterData;
    if(layoutId!=undefined){
      filterLayoutData=DesignTemplate.getDesignTemplatesByLayoutId(filterData, layoutId);
    }

    if(filterLayoutData.size == 0){
      dispatch(getcaterConcesDesignTemplates(designTypeId, designSizeId, businessTypeId, layoutId));
    } else {
      dispatch(resetcaterConcesDesignTemplatesState());
      dispatch(caterConcesDesignTemplatesAsyncActionSuccess(filterLayoutData));
    }
  };
}
